"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var youTubeId = function youTubeId(url) {
  var youTubeURL = new URL(url);
  var id = youTubeURL.searchParams.has('v') ? youTubeURL.searchParams.get('v') : null;
  if (id) return id;
  return youTubeURL.pathname.slice(1);
};

/**
 * Creates an `embed` content model with an optional title and content
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.sys.contentType
 * @param {object} entry.sys.contentType.sys
 * @param {string} entry.sys.contentType.sys.id
 * @param {object} entry.fields
 * @param {string} entry.fields.accessibleTitle - The accessible title of the embedded content
 * @param {string} entry.fields.embedType - The type of embedded content
 * @param {string} entry.fields.youtubeUrl - The `youtubeUrl` if the embed is a YouTube video
 * @param {string} entry.fields.typeformId - The ID of the Typeform form we are embedding
 * @returns {object} An `embed` content model
 */
var createEmbed = function createEmbed(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var youtubeUrl = (0, _utils.getProp)(fields, 'youtubeUrl');
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    accessibleTitle: (0, _utils.getProp)(fields, 'accessibleTitle'),
    embedType: (0, _utils.getProp)(fields, 'embedType'),
    youtubeUrl: youtubeUrl,
    videoId: youtubeUrl ? youTubeId(youtubeUrl) : null,
    typeformId: (0, _utils.getProp)(fields, 'typeformId'),
    frontUrl: (0, _utils.getProp)(fields, 'frontUrl')
  };
};
var _default = createEmbed;
exports["default"] = _default;